// extracted by mini-css-extract-plugin
module.exports = {"tuc_max_width":"960","medium_bp":"768","large_bp":"1200"};